// removed by extract-text-webpack-plugin
module.exports = {"flexRow":"Gcc0154 G8ee4b2 G57d356 G787698 G701143 Gc45158","flexItem":"G2610d2"};